<template>
  <div
    class     = "pa-2 pane"
  >
    <span class="text--secondary text-caption">{{ name }}</span>

    <slot></slot>
  </div>
</template>

<script>

export default {

  // #region Properties

  props: {
    name: String,
  }

  // #endregion Properties

}

</script>

<style scoped lang="scss">

.pane {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius:    2px;
  display:          flex;
  flex-direction:   column;
}

</style>